const Refund = () => {
    return (
        <div className="flex gap-6 margin-x py-10 justify-center items-center">
            <h1 className="text-2xl font-bold text-black/80">Refund Policy</h1>
            <div></div>
        </div>
    );
};
export default Refund;
